import { axiosAuthAPI } from '@/axios';
import qs from 'qs';

const addUser = (newUser) => {
  return axiosAuthAPI.post('/accounts', newUser);
};

const loadUsers = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAuthAPI.get(`/accounts${query}`);
  }
  return axiosAuthAPI.get('/accounts');
};

const loadUserById = (accountId) => {
  return axiosAuthAPI.get(`/accounts/${accountId}`);
};

const updateUserByAccountId = (accountId, newUser) => {
  return axiosAuthAPI.put(`/accounts/${accountId}`, newUser);
};

const updateUserPassword = (accountId, password) => {
  return axiosAuthAPI.post(`/accounts/${accountId}/passwords`, password);
};

const suspendUser = (accountId) => {
  return axiosAuthAPI.post(`/accounts/${accountId}/suspend`);
};

const activateUser = (accountId) => {
  return axiosAuthAPI.post(`/accounts/${accountId}/activate`);
};

export {
  loadUsers,
  addUser,
  loadUserById,
  updateUserByAccountId,
  updateUserPassword,
  suspendUser,
  activateUser,
};
